import React, { useState } from "react";

const FilterDropDown = ({ options }) => {
    const [dropdownOpen, setDropDownOpen] = useState(false);

    return (
        <React.Fragment>
            <div className="flex flex-col justify-start items-start">
                <button
                    onClick={() => {setDropDownOpen(!dropdownOpen);}}
                    className="flex flex-shrink-0 justify-center items-center gap-1 h-[42px] px-3 py-[11px] text-sm font-semibold leading-tight text-slate-700 bg-white rounded-lg shadow border border-gray-300 hover:bg-gray-100 cursor-pointer"
                >
                    <img className="w-4 h-4" src="/icons/filter.svg" alt="icon"/>
                    <div>Filter</div>
                </button>
                {
                    dropdownOpen && (
                        <div
                            className="fixed inset-0 h-full w-full z-10"
                            x-show="dropdownOpen"
                            onClick={() => {setDropDownOpen(!dropdownOpen);}}
                        />
                    )
                }
                {
                    dropdownOpen && (
                        <div className="absolute py-2 w-64 bg-white rounded-md shadow-xl z-20 ing-0 ring-1 ring-black/10">
                            {
                                (options?.length > 0) && (
                                    options.map(
                                        option => {
                                            return (
                                                <label key={`filter-option-${option.label}`} className="px-4 cursor-pointer gap-x-2 py-1 text-xs capitalize text-gray-700 inline-flex leading-tight font-semibold cursor-pointer">
                                                    <input
                                                        className=" flex justify-center items-center p-0.5 bg-gray-50 rounded border border-blue-600 cursor-pointer"
                                                        type="checkbox"
                                                        checked={option.value}
                                                        onChange={(e) => { option.onChange(e.target.checked);}}
                                                    />
                                                    <div>{option.label}</div>
                                                </label>
                                            );
                                        }
                                    )
                                )
                            }
                        </div>
                    )
                }
            </div>
        </React.Fragment>
    );
};

export default FilterDropDown;